export default __webpack_public_path__ + "static/media/mobile_apiary_map_en.f69064b0.png";